<template>
<div class="leaderListDialog" v-if="dialogVisible">
<el-dialog @close='cancel' title="选择开团团长" :visible.sync="dialogVisible" width="650px">
    <div class="right_main_box">
        <div class="search_box">
            <div class="innerbox">
                <span>已选择<span class="tc-orange">{{selectedResult.length}}</span>个团长</span>
                <el-button @click="handleCheck" type="text" size="small">取消选择</el-button>
            </div>
            <div class="innerbox">
                <el-input placeholder="输入团长名称/联系号码" v-model="param.key" clearable></el-input>
                <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
            </div>
        </div>
        <div class="add_goods_tabs_box">
            <el-table :data="tableData" style="width: 100%" :show-header="true" ref="multipleTable"
                      @select="handleSelectionChange" @row-click="handleRowChange" @select-all="handleAllSelectionChange">
                <el-table-column type="selection" width="30" :selectable="selectable"></el-table-column>
                <el-table-column label="团长信息">
                    <template slot-scope="scope">
                        <div class="goods_item_box">
                            <img class="headerImg" v-lazy="scope.row.headerlogourl" alt>
                            <div>
                                <div>
                                    <span class="innerbox">{{scope.row.headername}}</span>
                                    <span  class="innerbox">电话：{{scope.row.linktel}}</span>
                                </div>
                                <div>
                                    <span class="tc-grey innerbox">成员：{{scope.row.fanscount}}</span>
                                    <span class="tc-grey innerbox">提货点：{{scope.row.ppcount}}</span>
                                    <span class="tc-orange innerbox">团长佣金：{{scope.row.brokeragerateheader}}%</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page" style="margin-top: 15px; text-align: center">
            <el-pagination
                background
                @current-change="handleSizeChange"
                :current-page.sync="page.page"
                :page-size="page.pageSize"
                :pager-count="11"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </div>
        <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="handleSure()">确 定</el-button>
        </div>
    </div>
</el-dialog>
</div>
</template>

<script>
import {getHostHeaderListByEvent} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'brandListDialog',
    data() {
        return {
            param: {
                eventid: '',
                hostroletype: '',
                key: '',
                status: '1'
            },
            page: {
                page: 1,
                pageSize: 20,
                pageCount: 0
            },
            total: 0,
            dialogVisible: false,
            tableData: [],
            selectedResult: []
        }
    },
    mounted() {
    },
    methods: {
        selectable(row, index) {
            return !!row.isdelete
        },
        handleCheck() {
            this.tableData.forEach(obj => {
                if (obj.isdelete && obj.isCheck) {
                    obj.isCheck = false
                    this._changeSelection(obj)
                    this.$refs.multipleTable.toggleRowSelection(obj, false)
                }
            })
            // this.$refs.multipleTable.clearSelection()
            let list = []
            this.selectedResult.forEach(obj => {
                if (obj.isopenevent) {
                    list.push(obj)
                }
            })
            this.selectedResult = list
        },
        handleSizeChange() {
            this._getList()
        },
        openDialog(headerlist, eventid) {
            this.param.eventid = eventid
            this.tableData = []
            this.dialogVisible = true
            this.selectedResult = this._.cloneDeep(headerlist)
            this._getList()
        },
        cancel() {
            this.param.key = ''
            this.page = {
                page: 1,
                pageSize: 20,
                pageCount: 0
            }
            this.selectedResult = []
            this.dialogVisible = false
        },
        handelQuery() {
            this.page.page = 1
            this.tableData = []
            this._getList()
        },
        // 获取不同类型下商品列表
        _getList() {
            this.setLoading(true)
            getHostHeaderListByEvent({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.$nextTick(() => {
                        this.selectedResult.forEach((obj,i) => {
                            this.tableData.forEach((obj2,j) => {
                                if (obj.headerid === obj2.headerinnerid) {
                                    obj2.isCheck = true
                                    this.$refs.multipleTable.toggleRowSelection(this.tableData[j])
                                    return false
                                }
                            })
                        })
                    })
                    this.total = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        handleAllSelectionChange(selection) {
            if (this.tableData.length == selection.length) {
                this.tableData.forEach((obj, i) => {
                    if (!obj.isCheck) {
                        obj.isCheck = true
                        this._changeSelection(obj)
                    }
                })
            } else {
                this.tableData.forEach((obj, i) => {
                    if (obj.isdelete) {
                        obj.isCheck = false
                        this._changeSelection(obj)
                    }
                })
            }
        },
        handleSelectionChange(selection, row) {
            row.isCheck = !row.isCheck
            this._changeSelection(row)
        },
        handleRowChange(row) {
            if (row.isCheck) {
                this.$refs.multipleTable.toggleRowSelection(row)
            } else {
                this.$refs.multipleTable.toggleRowSelection(row, false)
            }
            this._changeSelection(row)
        },
        _changeSelection(row) {
            if (row.isCheck) {
                let obj = {
                    headerid: row.headerinnerid,
                    isopenevent: !row.isdelete,
                    pplist: ''
                }
                this.selectedResult.push(obj)
            } else {
                this.selectedResult.forEach((obj1, index1) => {
                    if (obj1.headerid === row.headerinnerid) {
                        this.selectedResult.splice(index1, 1)
                    }
                })
            }
        },
        // 确定添加商品
        handleSure() {
            if (!this.selectedResult.length) {
                this.$message.error('请选择团长')
                return false
            }
            this.$emit('setLeaderList', this.selectedResult)
            this.cancel()
        },
        ...mapActions([
            'setLoading', 'setBrandBusiness'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user', 'brandBusiness'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.leaderListDialog{
    display: flex;
    .right_main_box{
        width: 100%;
    }
    .search_box {
        display: flex;
        margin-bottom: 10px;
        justify-content: space-between;
        .innerbox{
            display: flex;
            align-items: center;
        }
        .el-input {
            width: 240px;
        }
        .el-input__inner {
            height: 32px;
        }
        .el-input__icon {
            line-height: 32px;
        }
        .el-button,
        .el-button--mini {
            height: 32px;
            width: 96px;
            margin-left: 20px;
            margin-bottom: 0px;
        }
    }
    .add_goods_tabs_box {
        .el-table {
            min-height: 340px;
        }
        .goods_item_box {
            display: flex;
            align-items: center;
            height: 42px;
            box-sizing: border-box;
            .headerImg{
                width: 50px;
                height: 50px;
                margin-right: 20px;
            }
            .innerbox{
                margin-right: 20px;
            }
        }
        .el-table__empty-block {
            height: 340px;
            max-height: 340px;
        }
        .el-table__empty-text {
            position: relative;
            top: 80px;
        }
    }
    .el-table::before {
        height: 0;
    }
    .el-table__body-wrapper{
        height: 350px;
        overflow-y: auto !important;
    }
}
</style>
